import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { submit } from 'redux-form'
import { signOffFromSession } from '../../../../../actions/userAccount/authorize/unauthorize'
import { IStore } from '../../../../../reducers'
import {
  getUsername,
  isUserLoading,
} from '../../../../../reducers/userAccount/selectors/userAccount'
import {
  IAccountOptionsDispatch,
  IAccountOptionsProps,
  IAccountOptionsTheme,
} from './AccountOptions'

function mapStateToProps(state: IStore): IAccountOptionsProps {
  const isAuthorizing = isUserLoading(state)

  return isAuthorizing
    ? {
        isAuthorizing,
      }
    : {
        isAuthorizing,
        username: getUsername(state),
      }
}

function bindDispatchToProps(dispatch: Dispatch): IAccountOptionsDispatch {
  return {
    onLogout() {
      dispatch(signOffFromSession())
    },
    onReset() {
      dispatch(submit('changePassword'))
    },
  }
}

export default connect<IAccountOptionsProps,
  IAccountOptionsDispatch,
  IAccountOptionsTheme>(
  mapStateToProps,
  bindDispatchToProps,
)
